import { render, staticRenderFns } from "./WithdrawCompletedStep.vue?vue&type=template&id=649549ea&scoped=true"
import script from "./WithdrawCompletedStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawCompletedStep.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WithdrawCompletedStep.vue?vue&type=style&index=0&id=649549ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649549ea",
  null
  
)

export default component.exports